import config from '@/config'

function americanPrice (price) {
  let priceus = {
    price: price,
    sign: ''
  }
  if (price >= 2) {
    priceus.price = 100 * (price - 1)
  } else {
    priceus.price = -100 / (price - 1)
  }

  if (!price || price === 1) {
    priceus.price = 0
  }

  // priceus.price = Math.round(priceus.price * 100) / 100
  priceus.price = parseFloat(priceus.price.toFixed(0))
  priceus.sign = priceus.price < 0 ? '' : '+'
  // return priceus
  let formatted = priceus.sign + priceus.price
  // console.log('americanPrice: ' + price + ' => ' + formatted)
  return formatted
}

function formatSelectionPrice (selection, isoutright) {
  var price
  let priceUp = selection.currentpriceup || selection.PriceUp
  let priceDown = selection.currentpricedown || selection.PriceDown
  if (!isNaN(parseFloat(priceUp)) && !isNaN(parseFloat(priceDown))) {
    price = 1 + parseFloat(priceUp) / parseFloat(priceDown)
  }
  //
  if (config.app.autoconf.US_PRICE_FORMAT_SIMPLE_FRACTIONS && selection.idfosporttype !== 'BOXING' && isoutright &&
    (priceUp === 1 || priceDown === 1 || priceDown === 2)) {
    return priceUp + '/' + priceDown
  }
  //
  // console.log('formatSelectionPrice', selection, price)
  return formatOdds(price)
}

function formatOdds (price) {
  // console.log('formatOdds:', price)
  if (!isNaN(parseFloat(price))) {
    if (config.app.priceFormat === 'US') {
      let priceus = americanPrice(price)
      return priceus
    } else {
      return price.toFixed(2)
    }
  } else {
    return undefined
  }
}

function reCalculatePrice (selection) {
  var price = false
  if (selection.currentpriceup && selection.currentpricedown) {
    price = 1 + selection.currentpriceup / selection.currentpricedown
    price = parseFloat(price.toFixed(14))
  }
  price = price || selection.price
  return price
}

function formatBetTypePrice (allowedBetTypesAndReturns) {
  let potentialReturn = (allowedBetTypesAndReturns && allowedBetTypesAndReturns.PotentialReturn) || 0
  let unitCount = (allowedBetTypesAndReturns && allowedBetTypesAndReturns.UnitCount) || 1
  // let price = potentialReturn - unitCount + 1
  let price = potentialReturn / unitCount
  return formatOdds(price)
}

function roundToPrecision (num, p) {
  p = typeof p === 'number' ? p : 2
  let n = Number(num) || 0
  // let multiplier = Math.pow(10, p)
  let s = 1
  if (n < 0) {
    s = -1
    n = Math.abs(n)
  }
  //
  n = n.toString().includes('e') ? n.toFixed(p + 3) : n
  let r = +(Math.round(n + 'e+' + p) + 'e-' + p)
  // let r = Math.round((n * multiplier) * (1 + Number.EPSILON)) / multiplier
  // let r = Vue._.round(n, p)
  //
  r *= s
  // console.log('rounding:', num, 'to:', r)
  return r
}

export default {
  formatSelectionPrice,
  formatBetTypePrice,
  formatOdds,
  reCalculatePrice,
  roundToPrecision
}



// WEBPACK FOOTER //
// ./src/library/priceFormat/index.js